
<ag-grid-angular id="agGrid" *ngIf="rowData.length > 0"
    style="height: 75vh; width: 100%; " (cellEditingStarted)="onCellEditingStarted($event)" (gridReady)="onGridReady($event)"
    class="ag-theme-balham" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [rowData]="rowData" 
   [animateRows]="true"></ag-grid-angular>

